import { motion } from "framer-motion";
import { Flame } from "lucide-react";

const LABELS = { 1: "Apenitas", 2: "Suavecito", 3: "Medio", 4: "Picante", 5: "¡Fuego total!" };
const COLORS = ["#3E9B4F", "#A8C22A", "#F2A007", "#E4572E", "#D2042D"];

export function SpiceIndicator({ level = 1, interactive = false, showLabel = true, size = 16 }) {
  const safe = Math.min(5, Math.max(1, level || 1));
  const hot = safe >= 4;
  return (
    <div className="flex items-center gap-2" data-testid="spice-indicator">
      <div className="flex gap-0.5" role="img" aria-label={`Nivel de picor: ${safe} de 5`}>
        {[1, 2, 3, 4, 5].map((i) => (
          <motion.span
            key={i}
            className="inline-flex"
            whileHover={interactive ? { scale: 1.35, rotate: [0, -14, 12, 0] } : undefined}
            animate={hot && i <= safe ? { x: [0, -1.5, 1.5, 0] } : undefined}
            transition={hot && i <= safe ? { repeat: Infinity, duration: 0.45, delay: i * 0.06 } : { duration: 0.25 }}
          >
            <Flame
              size={size}
              strokeWidth={1.8}
              style={
                i <= safe
                  ? { color: COLORS[i - 1], fill: COLORS[i - 1] }
                  : { color: "#D8E2EF", fill: "none" }
              }
            />
          </motion.span>
        ))}
      </div>
      {showLabel && (
        <span className="text-xs font-semibold uppercase tracking-wide text-clay">
          {LABELS[safe]}
        </span>
      )}
    </div>
  );
}

